// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"BU-z","inlineTitle":"CU-z","sponsoredAdsWrapper":"DU-z","marketplaceRecosWrapper":"EU-z"};